import { atom } from 'recoil';

import { GiftSelectedOption } from '@shared/api/giftOrder/giftOrder.interface';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'giftCart',
  storage: typeof window !== 'undefined' ? localStorage : undefined,
});

export interface GiftCartItem {
  itemId: string;
  itemName: string;
  itemImage?: string;
  priceRetail: number;
  quantity: number;
  minOrderQuantity: number;
  orderUnit: number;
  bugoId: string;
  /** 선택한 추가옵션 (있을 때만). 단가 = priceRetail + Σ priceDelta */
  selectedOptions?: GiftSelectedOption[];
}

export const giftCartAtom = atom<GiftCartItem[]>({
  key: 'giftCartAtom',
  default: [],
  effects_UNSTABLE: [persistAtom],
});
